import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import {
  getNavigationExtrasForHttpErrorResponse,
  handleRenavigationError,
  idWithoutDotHtml,
} from '®shared/router';

import { ListResolverStoreService } from '../resolver-store';

@Injectable()
export class CanActivatePublishedListView implements CanActivate {
  constructor(
    private listResolverStoreService: ListResolverStoreService,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const listId = idWithoutDotHtml(route.params.listId);
    const isEmbedded = route.queryParamMap.has('embed');

    return this.listResolverStoreService.hasPublishedReadingList(listId).pipe(
      catchError(error => {
        if (
          error instanceof HttpErrorResponse &&
          error.status === 404 &&
          isEmbedded
        ) {
          this.router.navigate(
            ['lti-missing-content'],
            getNavigationExtrasForHttpErrorResponse(error),
          );
          return of(false);
        } else {
          return handleRenavigationError(this.router)(error);
        }
      }),
    );
  }
}
